// extracted by mini-css-extract-plugin
export default {"screen":"screen__aqRhKe","intro":"intro__XqMCcv"};